import { Component, inject, Renderer2 } from '@angular/core';
import { startWith } from 'rxjs/operators';

import { euroinnovaConf } from '../environments/customer.conf';
import { CustomerConfInterface } from '../interfaces/customerConf.interface';
import { Customer, CustomerModulesDict } from '../models/customer';
import { ApiService } from '../services/api.service';
import { CustomerService } from '../services/customer.service';
import { VerticalSelectorService } from '../services/vertical-selector.service';
import { StyleManager } from '../shared-components/style-manager';
import { getStorageObject, setStorageObject } from '../utils/storage-manager';
import { SubdomainConfigService } from './subdomain-config.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private apiService = inject(ApiService);
  private styleManager = inject(StyleManager);
  private subdomainConfig = inject(SubdomainConfigService);
  private renderer = inject(Renderer2);
  private verticalSelectorService = inject(VerticalSelectorService)
  private customerService: CustomerService = inject(CustomerService);

  title = 'EVA';

  /**
   * Config for the current customer
   */
  customerConfig: CustomerConfInterface = euroinnovaConf;

  currentCustomer?: Customer;

  constructor() {
    this.verticalSelectorService.selectedVertical$.pipe(startWith(null)).subscribe((domain) => {
      const customer = getStorageObject('vertical');

      if (domain) {
        this.customerService.getCustomerModules(customer.domain).subscribe((customerModules) => {
          customer.modules = customerModules.modules as Partial<CustomerModulesDict>
          setStorageObject('vertical', customer);
          this.currentCustomer = customer;
          this.changeFaviconAndTitle();
        })
      } else {
        this.currentCustomer = customer;
      }
      this.customerConfig = this.subdomainConfig.getConfigForSubdomain(this.apiService.getApiSubdomain());
      this.styleManager.setStyle('theme', this.customerConfig);
      this.changeFaviconAndTitle();
    });
  }

  /**
   * Method to change the favicon and the title of the app
   */
  changeFaviconAndTitle(): void {
    const existingFavicon = document.querySelector("link[rel*='icon']");
    if (existingFavicon) {
      this.renderer.removeChild(document.head, existingFavicon);
    }
    const faviconLink = this.renderer.createElement('link');
    faviconLink.setAttribute('rel', 'icon');
    faviconLink.setAttribute('type', 'image/x-icon');
    faviconLink.setAttribute('href', this.currentCustomer?
      (this.currentCustomer.logoUrlBase + 'favicon.ico'): this.customerConfig.appIcon);
    this.renderer.appendChild(document.head, faviconLink);
    document.title = this.currentCustomer? this.currentCustomer.name: this.customerConfig.appName;
  }
}
